"use strict";
'use es6';

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime/helpers/createClass"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime/helpers/possibleConstructorReturn"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime/helpers/getPrototypeOf"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime/helpers/inherits"));

var _react = _interopRequireDefault(require("react"));

var _Functions = require("../core/Functions");

var FocusProvider =
/*#__PURE__*/
function (_React$Component) {
  (0, _inherits2.default)(FocusProvider, _React$Component);

  function FocusProvider(props) {
    var _this;

    (0, _classCallCheck2.default)(this, FocusProvider);
    _this = (0, _possibleConstructorReturn2.default)(this, (0, _getPrototypeOf2.default)(FocusProvider).call(this, props));
    _this.state = {
      focused: false
    };
    _this.handleFocus = _this.handleFocus.bind((0, _assertThisInitialized2.default)(_this));
    _this.handleBlur = _this.handleBlur.bind((0, _assertThisInitialized2.default)(_this));
    return _this;
  }

  (0, _createClass2.default)(FocusProvider, [{
    key: "handleFocus",
    value: function handleFocus(evt) {
      (0, _Functions.callIfPossible)(this.props.onFocus, evt);
      if (this.state.focused !== true) this.setState({
        focused: true
      });
    }
  }, {
    key: "handleBlur",
    value: function handleBlur(evt) {
      (0, _Functions.callIfPossible)(this.props.onBlur, evt);
      if (this.state.focused !== false) this.setState({
        focused: false
      });
    }
  }, {
    key: "render",
    value: function render() {
      var _this$props = this.props,
          children = _this$props.children,
          focusedProp = _this$props.focused;
      var focused = this.state.focused;
      return children({
        focused: focusedProp != null ? focusedProp : focused,
        onFocus: this.handleFocus,
        onBlur: this.handleBlur
      });
    }
  }]);
  return FocusProvider;
}(_react.default.Component);

FocusProvider.displayName = 'FocusProvider';
var _default = FocusProvider;
exports.default = _default;
module.exports = exports.default;